export const PAGINATION_RATE = 20
